/**
 * Get and expose build vars.
 */

declare const __APP_VERSION__: string;
declare const __COMMIT_HASH__: string;
declare const __BUILD_DATE__: string;
declare const __BUILD_NUMBER__: string;

export const getAppVersion = (): string => __APP_VERSION__;
export const getCommitHash = (): string => __COMMIT_HASH__;
export const getBuildDate = (): string => __BUILD_DATE__;
export const getBuildNumber = (): string => __BUILD_NUMBER__;
